<template>
  <div class="configurator-page-filter-group configurator-page-filter-group--depths">
    <h3 class="heading" id="filter-group-depths">{{ pointStore.depths.heading }}</h3>
    <div aria-labelledby="filter-group-depths" class="depth">
      <div class="configurator-page-filter-group__depth-level"
           :class="[depth.class, depth.disabled ? 'configurator-page-filter-group__item--disabled' : 
           '', depth.selected ? 'configurator-page-filter-group__item--selected' : '']"
           v-on:click="toggleDepth($event, depth)"
           v-for="depth in pointStore.depths.list"
           v-bind:key="depth.Id">
        <span>{{ depth.range }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import {usePointStore} from '../store/store';

const pointStore = usePointStore();
const props = defineProps({
  depths: Object
});

const emit = defineEmits([
  'clicked',
  'toggleDepth'
]);

function toggleDepth(event, depth) {
  emit('clicked', depth);
  emit('toggleDepth', depth);
}


</script>